module.exports = __webpack_public_path__ + "static/media/custom-ex-19.d1a3d212.jpg";